<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'transactions'" [businessName]="vm.businessName" [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>

<div class="container" *ngIf="!vm.isOpening">
  <div class="row pt-4 ">
    <div class="col-md-6 section-header">Add Bulk Water Usage</div>
  </div>
  <div>
    <hr class="mt-0 mb-1" />
  </div>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <form>

        <div>

          <div class="row">
            <div class="col">
              <label>Vehicle *</label>
              <select class="form-control" name="vehicles" [(ngModel)]="vm.vehicleId"
              [ngClass]="{'is-invalid': !!error('vehicleId')}" (change)="calculateCost()">
                <option [value]=""></option>
                <option *ngFor="let c of vm.vehicles" [value]="c.vehicleId">
                  {{c.description}}
                </option>
              </select>
              <div class="invalid-feedback"> {{error('vehicleId')}} </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label>Fill type *</label>
              <select class="form-control" name="fillType" [(ngModel)]="vm.fillType"
              [ngClass]="{'is-invalid': !!error('fillType')}" (change)="calculateCost()">
                <option  value="Loads">Number of fills</option>
                <option  value="Litres">Number of litres</option>
              </select>
            </div>
            <div class="col-6"  *ngIf="vm.fillType === 'Loads' ">
              <label>Number of Fills *</label>
              <input class="form-control" [ngClass]="{'is-invalid': !!error('fillLoads')}"
              name="fillLoads"
                placeholder="" type="text" [(ngModel)]="vm.fillLoads" (change)="calculateCost()">
              <div class="invalid-feedback"> {{error('fillLoads')}} </div>
            </div>
              <div class="col-6" *ngIf="vm.fillType === 'Litres' ">
              <label>Number Litres *</label>
              <input class="form-control" [ngClass]="{'is-invalid': !!error('fillLitres')}" name="fillLitres"
                placeholder="" type="text" [(ngModel)]="vm.fillLitres" (change)="calculateCost()">
              <div class="invalid-feedback"> {{error('fillLitres')}} </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <label>Month *</label>
              <select class="form-control" name="fillMonth" [(ngModel)]="vm.fillMonth"
              [ngClass]="{'is-invalid': !!error('fillMonth')}" >
                <option [value]=""></option>
                <option *ngFor="let c of vm.months" [value]="c.monthId">
                  {{c.description}}
                </option>
              </select>
              <div class="invalid-feedback"> {{error('fillMonth')}} </div>
            </div>
          </div>

          <div class="row">

            <div class="col-6">
              <label>Price per kL</label>
              <h6 class="font-weight-bold">{{vm.usageRate  | currency:false:'symbol':'0.4'}}</h6>
            </div>

            <div class="col-6">
              <label>Capacity</label>
              <h6 class="font-weight-bold">{{vm.usage}}</h6>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <label>Total Litres</label>
              <h6 class="font-weight-bold">{{vm.fillType === 'Loads' ? vm.fillLoads * vm.usage : vm.fillLitres}}</h6>
            </div>
            <div class="col-6">
              <label>Total Cost</label>
              <h6 class="font-weight-bold">{{vm.usageCost  | currency:false:'symbol':'0.4'}}</h6>
            </div>
            <div class="col-6">
            </div>
          </div>
          <div class="row pt-2">
            <div class="col">
              <label>Attachments</label>
              <div>
                  <cli-file-upload [objectId]="vm.waterUsageId" [objectType]="'Transaction'"
                  [fileList]="vm.fileList" buttonText="Upload"></cli-file-upload>
              </div>
            </div>
          </div>
        </div>
        <div>
          <hr class="mt-0 mb-1" />
        </div>
        <div class="d-flex justify-content-end">
          <div><button type="button" class="btn btn-primary" (click)="proceedYes()">OK</button></div>
          <div><button type="button" class="btn btn-link" (click)="proceedCancel()">Cancel</button></div>
        </div>
      </form>
    </div>
  </div>
